module.exports = __webpack_public_path__ + "static/p5-45976991455b23388c63ef51786a65cd.jpg";